// extracted by mini-css-extract-plugin
export var drawerContent = "_3c-0";
export var valueBlock = "_3c-1";
export var valueBlockFrom = "_3c-2 _3c-1";
export var valueBlockTo = "_3c-3 _3c-1";